export default __webpack_public_path__ + "static/img_0290-5e3b8f6afceaa735ed5b3d3a900ae82e.png";